import React from 'react';
import {
  formatDate,
} from 'utils/date';
import {
  formatPhone,
  isEmptyString,
} from '@populateui/utils';
import {
  getAddressString,
} from 'utils/string';
import Skeleton from 'core/components/Skeleton';
import {
  InsuranceDataForm,
} from 'views/EMR/components/Insurance/Dialog/InsuranceForm';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

type Props = Partial<Pick<InsuranceDataForm,
  | 'demographics'
  | 'insuranceOwnerPhoneNumber'
  | 'insuranceOwnerAddress'
>> & {
  hasAddress?: boolean;
  phone?: string;
  showHeader?: boolean;
  isLoading?: boolean;
};

export default function DemographicsHeader({
  demographics,
  insuranceOwnerPhoneNumber: phone,
  insuranceOwnerAddress: address,
  hasAddress = false,
  showHeader = true,
  isLoading = false,
}: Props) {
  return (
    <div className="flex flex-col w-full font-normal text-black">
      {showHeader && (
        <h3 className="font-semibold text-gray-500 mb-0.5">
          Subscriber&rsquo;s Information
        </h3>
      )}
      {isLoading ? (
        <div className="flex flex-col gap-1.5">
          <Skeleton variant="rectangular" className="!h-3 !w-3/5 rounded" />
          <Skeleton variant="rectangular" className="!h-3 !w-2/5 rounded" />
          <Skeleton variant="rectangular" className="!h-3 !w-2/5 rounded" />
        </div>
      ) : (
        <>
          <p>
            <strong>
              {getDisplayName(demographics?.formattedNames, '--')}
              {` (${demographics?.genderDescription})`}
            </strong>
            {' born on '}
            <strong>
              {formatDate(demographics?.dateOfBirth ?? '')}
            </strong>
          </p>
          {hasAddress && (
            <p>{getAddressString(address, true)}</p>
          )}
          {!isEmptyString(phone) && (
            <p>{formatPhone(phone ?? '')}</p>
          )}
        </>
      )}
    </div>
  );
}
